import { render } from "./TableInput.vue?vue&type=template&id=0a4f8dc2"
import script from "./TableInput.vue?vue&type=script&lang=js"
export * from "./TableInput.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/nice-life-contract/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__